module.exports = __webpack_public_path__ + "img/a2.a4659407.jpg";